import { grey } from "@material-ui/core/colors"
export const inputStyles = {
  letterSpacing: 1,
  colorLabel: grey[700],
  fontSizeTitle: 14,
}
